const BcError = ({ errorMessage }) => {
  return <div className="error-message">{errorMessage}</div>;
};

export { BcError };
